let claimOwnershipDeviceId = null;

export const setClaimOwnershipDeviceId = (value) => {
  claimOwnershipDeviceId = value || null;
};

export const getClaimOwnershipDeviceId = () => claimOwnershipDeviceId;
